<template>
  <div class="terms-form">
    <div class="terms-form__inner">
      <div v-if="hasPolicy()">
        <h3>Policies</h3>

        <div class="policy-content" v-html="$store.state.app_data.policies_text"></div>
      </div>
      
      <h3>Terms & Conditions</h3>

      <div
        :class="{ 'field-group': true, checkbox: true, error: errors.terms }"
      >
        <input
          type="checkbox"
          name="terms"
          v-model="terms"
          required="true"
          @change="validate($event.target)"
          aria-label="Terms and Conditions"
        />
        <label v-html="termsText"></label>
        <span class="error-msg" v-if="errors.terms">
          {{errors.terms}}
        </span>
      </div>
      <div class="field-group checkbox">
        <input type="checkbox" name="optin" v-model="optin" />
        <label v-html="$store.state.app_data.newsletter_text"></label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  props: ['errors'],
  computed: {
    ...mapFields([
      'form.terms',
      'form.optin'
    ]),
    termsText() {
      let text = this.$store.state.app_data.terms_text
      let host = new URL(window.location.href).host
      // replace host for whitelabel sites
      text = text.replace(this.$store.state.app_data.host, host)
      return text
    }
  },
  methods: {
    hasPolicy() {
      let text = this.$store.state.app_data.policies_text
      return (text && text.length > 0)
    },
    validate(field) {
      if (!this.$parent.$data.valid) {
        if (field.checkValidity()) {
          field.parentNode.classList.remove('error')
          this.$parent.errors[field.name] = null
        }
      }
    }
  }
}
</script>

<style>
  .terms-form {
    padding: 0 28px;
    &__inner {
      border-top: 2px solid #dcdcdc;
      border-bottom: 2px solid #dcdcdc;
      padding: 40px 0;
    }

    .policy-content {
      margin: 28px 0;
    }

    .field-group {
      &.checkbox {
        display: flex;
        flex-flow: row;

        &.error {
          .error-msg {
            bottom: -16px;
          }
        }

        input {
          width: 20px;
          height: 20px;
          margin: 25px 15px 0 0;
          padding: 10px;
          appearance: none;
          border: 1px solid $pumpkin;

          &:checked {
            background-color: $pumpkin;
            background-image: url(~icons/checkmark-white.svg);
            background-size: 75%;
            background-position: 50% 50%;
            background-repeat: no-repeat;
          }
        }
        label {
          font-size: 16px;
          line-height: 1.38;
          letter-spacing: 0.25px;
          color: #555;
        }
      }
    }

    @mixin breakpoint $tablet {
      padding: 0 50px;
    }
  }
</style>
